import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_2 = {
  key: 0,
  class: "modal-title"
}
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = {
  key: 1,
  class: "modal-footer"
}

import { onMounted, onUnmounted, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    modelValue: { type: Boolean },
    title: {},
    size: { default: 'md' },
    showClose: { type: Boolean, default: true },
    closeOnOverlay: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const close = () => {
  emit('update:modelValue', false)
  emit('close')
}

const handleOverlayClick = () => {
  if (props.closeOnOverlay) {
    close()
  }
}

const handleEscape = (e: KeyboardEvent) => {
  if (e.key === 'Escape' && props.modelValue) {
    close()
  }
}

// Lock body scroll when modal is open
watch(() => props.modelValue, (isOpen) => {
  if (isOpen) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
})

onMounted(() => {
  document.addEventListener('keydown', handleEscape)
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleEscape)
  document.body.style.overflow = ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (__props.modelValue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-overlay",
              onClick: handleOverlayClick
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["modal-container", [`modal-${__props.size}`]]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                (__props.title || __props.showClose)
                  ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
                      (__props.title)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(__props.title), 1))
                        : _createCommentVNode("", true),
                      (__props.showClose)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "close-btn",
                            onClick: close
                          }, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("svg", {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                              fill: "none"
                            }, [
                              _createElementVNode("path", {
                                d: "M5 5L15 15M5 15L15 5",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round"
                              })
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                (_ctx.$slots.footer)
                  ? (_openBlock(), _createElementBlock("footer", _hoisted_4, [
                      _renderSlot(_ctx.$slots, "footer")
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})